class Product {
  constructor (data) {
    this.id = data ? data.id : ''
    this.category_id = data ? data.category_id : ''
    this.categoryName = data ? data.categoryName : null
    this.name = data ? data.name : ''
    this.product_no = data ? data.product_no : ''
    this.upc = data ? data.upc : ''
    this.sort_no = data ? data.sort_no : 0
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : true
    this.thumbnail = data ? data.thumbnail : null
    this.thumbnailUrl = data ? data.thumbnailUrl : null
    this.keywords = data ? data.keywords : null
    this.downloads = data ? data.downloads : -1
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('category_id', this.category_id)
    formData.append('name', this.name)
    formData.append('product_no', this.product_no)
    formData.append('upc', this.upc)
    formData.append('sort_no', this.sort_no)
    formData.append('is_enabled', this.is_enabled === true)
    formData.append('thumbnail', this.thumbnail)
    formData.append('keywords', this.keywords)
    return formData
  }
}

export default Product



// WEBPACK FOOTER //
// ./src/models/Product.js